import React from 'react';
import {
    // Базовые иконки
    FileIcon,
    // Документы
    DocIcon,
    DocxIcon,
    MdIcon,
    PdfIcon,
    TxtIcon,
    RtfIcon,
    // Аудио
    AacIcon,
    FlacIcon,
    M4aIcon,
    Mp3Icon,
    OggIcon,
    OpusIcon,
    WavIcon,
    WmaIcon,
    WmfIcon,
    // Тёмные версии
    DarkDocIcon,
    DarkDocxIcon,
    DarkMdIcon,
    DarkPdfIcon,
    DarkTxtIcon,
    DarkRtfIcon,
    DarkAacIcon,
    DarkFlacIcon,
    DarkM4aIcon,
    DarkMp3Icon,
    DarkOggIcon,
    DarkOpusIcon,
    DarkWavIcon,
    DarkWmaIcon,
    DarkWmfIcon,
} from '../../assets/icons';

/**
 * Возвращает иконку файла в зависимости от расширения и текущей темы.
 * @param {string} fileName - Имя файла (с расширением).
 * @param {string} theme - Тема: 'light' или 'dark'.
 * @returns {JSX.Element} React-элемент иконки.
 */
export const getFileIcon = (fileName, theme = 'light') => {
    if (!fileName) return <FileIcon className="file-icon-svg" />;

    const extension = fileName.split('.').pop().toLowerCase();

    // Сопоставление расширений с иконками
    const iconsMap = {
        // Документы
        pdf: { light: PdfIcon, dark: DarkPdfIcon },
        doc: { light: DocIcon, dark: DarkDocIcon },
        docx: { light: DocxIcon, dark: DarkDocxIcon },
        md: { light: MdIcon, dark: DarkMdIcon },
        txt: { light: TxtIcon, dark: DarkTxtIcon },
        rtf: { light: RtfIcon, dark: DarkRtfIcon },
        // Аудио
        mp3: { light: Mp3Icon, dark: DarkMp3Icon },
        wav: { light: WavIcon, dark: DarkWavIcon },
        wma: { light: WmaIcon, dark: DarkWmaIcon },
        wmf: { light: WmfIcon, dark: DarkWmfIcon },
        aac: { light: AacIcon, dark: DarkAacIcon },
        flac: { light: FlacIcon, dark: DarkFlacIcon },
        m4a: { light: M4aIcon, dark: DarkM4aIcon },
        ogg: { light: OggIcon, dark: DarkOggIcon },
        opus: { light: OpusIcon, dark: DarkOpusIcon },
    };

    const iconSet = iconsMap[extension];
    if (iconSet) {
        const IconComponent = theme === 'light' ? iconSet.light : iconSet.dark;
        return <IconComponent className="file-icon-svg" />;
    }

    // Если расширение не найдено — возвращаем стандартную иконку
    return <FileIcon className="file-icon-svg" />;
};